module.exports = "../images/moose-bg@2x.jpg?v=aeca60e";